<div class="row">
  <div class="col-12 mb-2">
    <table
      datatable
      [dtOptions]="dtOptions"
      [dtTrigger]="dtTrigger"
      class="table table-striped mb-0"
    >
      <thead>
        <tr>
          <td style="width: 5px">Id</td>
          <th style="width: 120px">Changed On</th>
          <th style="width: 120px">Changed By</th>
          <th style="width: 120px">Source</th>
          <th style="width: 120px">Low Balance Threshold</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let vas of vasDetails">
          <td style="font-size: 12px">{{ vas.id }}</td>
          <td style="font-size: 12px">
            {{ vas.changedOn | date: "MMM d, y, h:mm:ss a" }}
          </td>
          <td style="font-size: 12px">{{ vas.changedBy }}</td>
          <td style="font-size: 12px">{{ vas.source }}</td>
          <td style="font-size: 12px">{{ vas.lowBalanceThreshold }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="page-title-box">
      <div class="page-title-right">
        <input
          type="button"
          value="Print"
          class="btn btn-success"
          (click)="print()"
        />
        &nbsp;
        <input
          type="button"
          value="Export to CSV"
          class="btn btn-success"
          (click)="DownloadCsv()"
        />
      </div>
    </div>
  </div>
</div>
